import { render, staticRenderFns } from "./TeamDashboard.view.vue?vue&type=template&id=24d890f8&scoped=true&"
import script from "./TeamDashboard.view.vue?vue&type=script&lang=js&"
export * from "./TeamDashboard.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d890f8",
  null
  
)

export default component.exports